import typeCheck from 'common/util/typeCheck';
import { SR_API_ACTION_HOUSEHOLD_GET_LISTINGS_APPLYING_FOR } from 'api/actionTypes';

export default async function getListingsApplyingFor(
  { state, apiClient },
  { householdId, householdListingId },
) {
  typeCheck('householdId::Maybe PositiveNumber', householdId);
  typeCheck('listingId::Maybe PositiveNumber', householdListingId);
  await apiClient.postWithState({
    action: SR_API_ACTION_HOUSEHOLD_GET_LISTINGS_APPLYING_FOR,
    queryId: householdId ? `hh-${householdId}` : `hhl-${householdListingId}`,
    state: state,
    payload: {
      householdId,
      householdListingId,
    },
    onSuccess(listingsApplyingFor) {
      if (householdId) {
        state.set(
          ['household', 'listingsApplyingFor', 'byHouseholdId', householdId],
          listingsApplyingFor,
        );
        return;
      }
      state.set(
        ['household', 'listingsApplyingFor', 'byHouseholdListingId', householdListingId],
        listingsApplyingFor,
      ); // eslint-disable-line max-len
    },
  });
}
